import $ from 'jquery';

$(function () {
    if ($('#all_in_one_page').length) {
        initVideoBindings();
    }

    function initVideoBindings() {
        var $modal = $('#all_in_one_page').closest('body').find('#videoModal'),
            videoSrc = $modal.find('iframe').attr("src");

        $modal.on('show.bs.modal', function () {
            if (videoSrc.indexOf('autoplay') !== -1) {
                $modal.find('iframe').attr("src", videoSrc);
            } else {
                $modal.find('iframe').attr("src", videoSrc+"&amp;autoplay=1");
            }
        });

        $modal.on('hidden.bs.modal', function (e) {
            $modal.find('iframe').attr("src", null);
        });
    }
});